import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";

export const sendItemLeaf = (async (data) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.ItemApis.ItemTree.itemLeaf,
    method: 'post',
    data:data
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const putItemLeaf = (async (data) => await http({
   baseURL:INVENTORYANDSALES_URL,
   url: ENDPOINTSINVENTORYANDSALES.Inventory.ItemApis.ItemTree.itemLeaf,
   method: 'put',
   data:data
   
}).then((res) => {

   return res.data
}).catch((err) => {

   return Promise.reject( err);
})

)


export const getItemLeaf = (id) => http({
    baseURL:INVENTORYANDSALES_URL,
   url: ENDPOINTSINVENTORYANDSALES.Inventory.ItemApis.ItemTree.itemLeaf,
   method: "get",
   params:{
    Id:id
   }
}).then((res) => {
   return res.data
}).catch((err) => {
   return Promise.reject(err.response  );
});